import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=4fea128d"
import script from "./TemplatePicker.vue?vue&type=script&lang=js"
export * from "./TemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=4fea128d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports